import React from 'react';
import Head from 'next/head';

export default function UnsupportBrowser() {
  return (
    <div>
      <Head>
        <title>지원하지 않는 브라우저</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta charSet="utf-8" />
      </Head>
      <div>
        <div className="container-wrapper">
          <div className="container">
            🚨Baby Shark World Admin은 Internet Explorer에서는 이용
            불가능합니다.{' '}
            <a href="https://www.google.com/chrome/">구글 크롬 브라우저</a>를
            이용해주세요.
          </div>
        </div>
        {/* language="CSS" */}
        <style jsx global>{`
          .container {
            padding: 24px 15px;
            margin-right: auto;
            margin-left: auto;
            background-color: #fff;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }

          .container-wrapper {
            position: relative;
            height: 100vh;
            background-color: #f0f2f5;
            padding: 20px;
          }
        `}</style>
      </div>
    </div>
  );
}
